module.exports = __webpack_public_path__ + "static/img/bg-ClientHover-07.bc85cf1b.png";